import type { PageData } from '@/types';
import * as ComponentData from './content.html';

const pageData: PageData = [
  {
    title:
      'Open Methane - An Open Platform for Understanding Australia\'s Methane Emissions',
    link: {
      title: 'About Open Methane',
      anchor: 'about-open-methane',
    },
    blocks: [
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C01,
          },
        ],
      },
      {
        link: {
          title: 'Our Mission',
          anchor: 'our-mission',
        },
        components: [
          {
            type: 'text',
            content: ComponentData.C02,
          },
        ],
      },
      {
        components: [
          {
            type: 'goals',
            content: '',
          },
        ],
      },
      {
        link: {
          title: 'Our Team',
          anchor: 'our-team',
        },
        components: [
          {
            type: 'text',
            content: ComponentData.C03,
          },
          {
            type: 'person',
            content: {
              name: 'Professor Peter Rayner',
              title: 'Science Lead',
              organisation: 'The Superpower Institute',
              bio: ComponentData.C0301,
              links: [
                {
                  title: 'LinkedIn',
                  url: 'https://au.linkedin.com/in/peter-rayner-5966b310b',
                  target: '_blank',
                },
                {
                  title: 'Google Scholar',
                  url: 'https://scholar.google.com/citations?user=H3up71wAAAAJ&hl=en',
                  target: '_blank',
                },
              ],
              image: '/img/peter-300px.png',
            },
          },
          // Thanks for everything Gerard, this project wouldn't have been
          // possible without you!
          // {
          //   type: 'person',
          //   content: {
          //     name: 'Gerard Mason',
          //     title: 'Head of Digital Products',
          //     organisation: 'The Superpower Institute',
          //   },
          // },
          {
            type: 'person',
            content: {
              name: 'Susannah Powell',
              title: 'Director / General Manager',
              organisation: 'The Superpower Institute',
            },
          },
          {
            type: 'person',
            content: {
              name: 'Adam Grant',
              title: 'Communications Director',
              organisation: 'The Superpower Institute',
            },
          },
          {
            type: 'person',
            content: {
              name: 'Scott Fairbanks',
              title: 'Design Director',
              organisation: 'The Superpower Institute',
            },
          },
          {
            type: 'person',
            content: {
              name: 'Lindsay Gaines',
              title: 'Principal Software Engineer',
              organisation: 'The Superpower Institute',
            },
          },
          {
            type: 'person',
            content: {
              name: 'Veronica Tran',
              title: 'Senior Designer',
              organisation: 'AKQA',
            },
          },
          {
            type: 'person',
            content: {
              name: 'Tim Devine',
              title: 'Executive Innovation Director',
              organisation: 'AKQA',
            },
          },
          {
            type: 'person',
            content: {
              name: 'Jared Lewis',
              title: 'Chief Technical Officer',
              organisation: 'Climate Resource',
            },
          },
          {
            type: 'person',
            content: {
              name: 'Dr. Mika Pflüger',
              title: 'Senior Research Software Engineer',
              organisation: 'Climate Resource',
            },
          },
          {
            type: 'person',
            content: {
              name: 'Daniel Busch',
              title: 'Research Software Engineer',
              organisation: 'Climate Resource',
            },
          },
        ],
      },
    ],
  },
  {
    title: 'Our Approach',
    link: {
      title: 'Our Approach',
      anchor: 'our-approach',
    },
    blocks: [
      {
        link: {
          title: 'Data and Methodology',
          anchor: 'data-and-methodology',
        },
        components: [
          {
            type: 'text',
            content: ComponentData.C04,
          },
        ],
      },
      {
        link: {
          title: 'Collaboration with Researchers',
          anchor: 'collaboration-with-researchers',
        },
        components: [
          {
            type: 'text',
            content: ComponentData.C05,
          },
        ],
      },
      {
        link: {
          title: 'Transparency & Accountability',
          anchor: 'transparency-and-accountability',
        },
        components: [
          {
            type: 'text',
            content: ComponentData.C06,
          },
        ],
      },
      {
        link: {
          title: 'Partnerships & Collaborators',
          anchor: 'partnerships-and-collaborators',
        },
        components: [
          {
            type: 'text',
            content: ComponentData.C07,
            notes: [
              {
                content: ComponentData.C0701,
              },
              {
                content: ComponentData.C0702,
              },
            ],
          },
        ],
      },
      {
        link: {
          title: 'Funding',
          anchor: 'funding',
        },
        components: [
          {
            type: 'text',
            content: ComponentData.C08,
          },
        ],
      },
    ],
  },
  {
    title: 'Get Involved',
    link: {
      title: 'Get Involved',
      anchor: 'get-involved',
    },
    blocks: [
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C09,
          },
        ],
      },
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C10,
          },
        ],
      },
      {
        components: [
          {
            type: 'text',
            content: ComponentData.C11,
          },
        ],
      },
    ],
  },
];

export default pageData;
